// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.permission-cycle-button {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 4px 0px;
  cursor: pointer;
  width: 74px;
  transition: background-color 0.2s ease, width 0.2s ease;
}
.permission-cycle-button.none {
  background-color: white;
  color: black;
}
.permission-cycle-button.view {
  background-color: #ADD8E6;
  color: black;
}
.permission-cycle-button.edit {
  background-color: #90EE90;
  color: black;
}
@media (min-width: 1290px) {
  .permission-cycle-button {
    width: 100px;
  }
}

.group-share-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
}
.group-share-table th,
.group-share-table td {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  vertical-align: middle;
  text-align: center;
}
.group-share-table th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}
.group-share-table tr {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.group-share-table td:first-child,
.group-share-table th:first-child {
  text-align: left;
}
.group-share-table td:last-child {
  white-space: nowrap;
  padding-right: 1rem;
}
.group-share-table button {
  font-size: 0.85rem;
}

.permission-dropdown {
  padding: 6px 2px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.8rem;
}
.permission-dropdown.none {
  background-color: white;
  color: #444343;
}
.permission-dropdown.view {
  background-color: #d0ebff;
  color: #004085;
}
.permission-dropdown.edit {
  background-color: #d4edda;
  color: #155724;
}

@media (max-width: 1520px) {
  .group-share-table {
    font-size: 0.8rem;
  }
  .group-share-table th,
  .group-share-table td {
    padding: 0.2rem 0.25rem;
    font-size: 0.75rem;
  }
  .group-share-table button {
    font-size: 0.7rem;
  }
  .group-share-table .permission-button {
    min-width: 70px;
  }
  .group-share-table td:last-child {
    white-space: nowrap;
    padding-right: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/GroupShareTable.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,uDAAA;AAUF;AARE;EACE,uBAAA;EACA,YAAA;AAUJ;AAPE;EACE,yBD0Bc;ECzBd,YAAA;AASJ;AANE;EACE,yBDsBc;ECrBd,YAAA;AAQJ;AALE;EAxBF;IAyBI,YAAA;EAQF;AACF;;AAJA;EACE,WAAA;EACA,yBAAA;EACA,sBAAA;AAOF;AALE;;EAEE,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAOJ;AAJE;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;AAMJ;AAHE;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AAKJ;AAFE;;EAEE,gBAAA;AAIJ;AADE;EACE,mBAAA;EACA,mBAAA;AAGJ;AAAE;EACE,kBAAA;AAEJ;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AACF;AACE;EACE,uBAAA;EACA,cDjDK;ACkDT;AAEE;EACE,yBAAA;EACA,cAAA;AAAJ;AAGE;EACE,yBAAA;EACA,cAAA;AADJ;;AAKA;EACE;IACE,iBAAA;EAFF;EAIE;;IAEE,uBAAA;IACA,kBAAA;EAFJ;EAKE;IACE,iBAAA;EAHJ;EAME;IACE,eAAA;EAJJ;EAOE;IACE,mBAAA;IACA,qBAAA;EALJ;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.permission-cycle-button {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 4px 0px;\n  cursor: pointer;\n  width: 74px;\n  transition: background-color 0.2s ease, width 0.2s ease;\n\n  &.none {\n    background-color: white;\n    color: black;\n  }\n\n  &.view {\n    background-color: $permission-blue;\n    color: black;\n  }\n\n  &.edit {\n    background-color: $permission-green;\n    color: black;\n  }\n\n  @media (min-width: 1290px) {\n    width: 100px;\n  }\n}\n\n\n.group-share-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 10px;\n\n  th,\n  td {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n    vertical-align: middle;\n    text-align: center;\n  }\n\n  th {\n    background-color: #f9f9f9;\n    font-weight: 600;\n    color: #333;\n  }\n\n  tr {\n    background-color: white;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  }\n\n  td:first-child,\n  th:first-child {\n    text-align: left;\n  }\n\n  td:last-child {\n    white-space: nowrap;\n    padding-right: 1rem;\n  }\n\n  button {\n    font-size: 0.85rem;\n  }\n}\n\n.permission-dropdown {\n  padding: 6px 2px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 0.8rem;\n\n  &.none {\n    background-color: white;\n    color: $grey4a;\n  }\n\n  &.view {\n    background-color: #d0ebff;\n    color: #004085;\n  }\n\n  &.edit {\n    background-color: #d4edda;\n    color: #155724;\n  }\n}\n\n@media (max-width: 1520px) {\n  .group-share-table {\n    font-size: 0.8rem;\n\n    th,\n    td {\n      padding: 0.2rem 0.25rem;\n      font-size: 0.75rem;\n    }\n\n    button {\n      font-size: 0.7rem;\n    }\n\n    .permission-button {\n      min-width: 70px;\n    }\n\n    td:last-child {\n      white-space: nowrap;\n      padding-right: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
